/* Nutra Nourish — Redesign v3 behaviour. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(function () {
    /* --- Hide the "leaky gut" quiz pop-up ---
       Injected by a third-party app, so it cannot be removed from the theme.
       Matched on wording rather than a vendor class name, so it works whichever
       app serves it, and no other pop-up on the store is affected.

       PROPER FIX: switch the form off in the app that owns it. This is a
       front-end suppression only — the app still believes it is running. */
    (function hideThirdPartyPopups() {
      var PHRASES = [/leaky\s*gut/i];
      var scheduled = false;

      function isOverlay(el) {
        var pos = getComputedStyle(el).position;
        return pos === 'fixed' || pos === 'absolute';
      }

      function hide(el) {
        el.dataset.nnHidden = '1';
        el.style.setProperty('display', 'none', 'important');
      }

      function sweep() {
        scheduled = false;
        var hitSomething = false;

        // Any element at any depth whose text mentions the phrase…
        var nodes = document.body.querySelectorAll('div, aside, section, dialog');
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (el.dataset.nnHidden) continue;
          if (el.closest('[data-nn-popup]')) continue;         // never our own popup
          if (el.offsetHeight < 150 || el.offsetWidth < 200) continue;
          var text = el.innerText || '';
          if (!text || text.length > 600) continue;
          var matched = PHRASES.some(function (re) { return re.test(text); });
          if (!matched) continue;

          // …then hide the outermost overlay wrapper around it, so the
          // backdrop goes too rather than leaving a grey screen.
          var target = el, node = el;
          for (var up = 0; up < 6 && node && node !== document.body; up++) {
            if (isOverlay(node)) target = node;
            node = node.parentElement;
          }
          if (!isOverlay(target) && !isOverlay(el)) continue;   // inline banner, leave it
          hide(target);
          hitSomething = true;
        }

        if (hitSomething) {
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
        }
      }

      function schedule() {
        if (scheduled) return;
        scheduled = true;
        window.setTimeout(sweep, 400);
      }

      schedule();
      if (typeof MutationObserver === 'function') {
        new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      }
      [1000, 2500, 5000, 8000, 12000, 20000].forEach(function (ms) { window.setTimeout(sweep, ms); });
      document.addEventListener('click', schedule, true);
    })();

    /* --- Never render a broken-image box ---
       Logos are referenced by URL, so a file that gets moved or deleted would
       otherwise show the browser's broken-image icon plus alt text. Hide the
       whole slot instead. */
    document.querySelectorAll('.media-strip-item img, .logos-row img').forEach(function (img) {
      function hide() {
        var slot = img.closest('.media-strip-item') || img;
        slot.style.display = 'none';
      }
      if (img.complete && img.naturalWidth === 0) { hide(); return; }
      img.addEventListener('error', hide);
    });

    /* --- Lead-magnet popup --- */
    (function leadPopup() {
      var popup = document.querySelector('[data-nn-popup]');
      if (!popup) return;

      var KEY = 'nn-guide-popup-seen';
      var frequency = popup.dataset.frequency || 'session';
      var store = frequency === 'once' ? window.localStorage : window.sessionStorage;
      var success = popup.querySelector('[data-nn-popup-success]');
      var form = popup.querySelector('form');

      function remember() {
        if (frequency === 'always') return;
        try { store.setItem(KEY, '1'); } catch (e) {}
      }

      function seen() {
        if (frequency === 'always') return false;
        try { return store.getItem(KEY) === '1'; } catch (e) { return false; }
      }

      function open() {
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
        var field = popup.querySelector('input[type="text"], input[type="email"]');
        if (field) field.focus();
      }

      function close() {
        popup.hidden = true;
        document.body.style.overflow = '';
        remember();
      }

      popup.querySelectorAll('[data-nn-popup-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) close();
      });

      /* Email the store admin alongside the customer signup.
         The visible form posts as a customer (so the address is captured in
         Admin → Customers); Shopify's contact endpoint is what actually sends
         mail. The notification must COMPLETE before we let the form navigate —
         firing it and navigating away made delivery a coin-flip. */
      if (form && popup.dataset.notifyAdmin === '1') {
        var notified = false;
        form.addEventListener('submit', function (event) {
          if (notified) return;            // second pass: let it through
          event.preventDefault();

          var btn = form.querySelector('[type="submit"]');
          if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

          var data = new FormData();
          var first = (form.querySelector('[name="contact[first_name]"]') || {}).value || '';
          var last = (form.querySelector('[name="contact[last_name]"]') || {}).value || '';
          var email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
          data.append('form_type', 'contact');
          data.append('utf8', '✓');
          data.append('contact[name]', (first + ' ' + last).trim());
          data.append('contact[email]', email);
          data.append('contact[body]',
            'Requested the free guide: ' + (popup.dataset.guide || 'guide') + '.');

          function proceed() {
            notified = true;
            if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
            else { form.submit(); }
          }

          // Don't strand the visitor if the notification hangs.
          var timeout = window.setTimeout(proceed, 4000);
          fetch('/contact', { method: 'POST', body: data })
            .catch(function () {})
            .then(function () { window.clearTimeout(timeout); proceed(); });
        });
      }

      if (success) {
        // Shopify redirects back here after the form posts. Strip the flag from
        // the URL so a refresh or Back doesn't replay the success state.
        open();
        remember();
        if (window.history && window.history.replaceState) {
          var url = window.location.pathname + window.location.search.replace(
            /[?&](customer_posted|contact_posted)=true/g, '').replace(/^&/, '?');
          window.history.replaceState({}, document.title, url);
        }
        return;
      }

      if (seen()) return;
      var delay = parseInt(popup.dataset.delay, 10);
      window.setTimeout(open, (isNaN(delay) ? 4 : delay) * 1000);
    })();

    /* --- Announcement bar dismiss (remembered for the session) --- */
    var announcement = document.querySelector('[data-nn-announcement]');
    if (announcement) {
      try {
        if (sessionStorage.getItem('nn-announcement-closed') === '1') {
          announcement.hidden = true;
        }
      } catch (e) { /* storage blocked — bar simply stays visible */ }

      var closeBtn = announcement.querySelector('[data-nn-announcement-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          announcement.hidden = true;
          try { sessionStorage.setItem('nn-announcement-closed', '1'); } catch (e) {}
        });
      }
    }

    /* --- Mobile nav --- */
    var navToggle = document.querySelector('[data-nn-nav-toggle]');
    var navLinks = document.querySelector('[data-nn-nav-links]');
    if (navToggle && navLinks) {
      navToggle.addEventListener('click', function () {
        var open = navLinks.classList.toggle('is-open');
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* --- Mobile: tap a parent item to expand its dropdown --- */
    document.querySelectorAll('[data-nn-has-dropdown] > a').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (window.matchMedia('(max-width: 860px)').matches) {
          var parent = link.parentElement;
          if (!parent.classList.contains('is-expanded')) {
            event.preventDefault();
            parent.classList.add('is-expanded');
          }
        }
      });
    });

    /* --- "Featured in" logo carousel ---
       Mirrors the nutranourish.com Swiper: infinite loop, 5-up paging,
       500ms slide, 5s autoplay that stops once the visitor interacts.
       Transform-based rather than scrollLeft: percentage-width flex items in a
       scroll container don't reliably register scrollable overflow. */
    document.querySelectorAll('[data-nn-logo-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-nn-logo-track]');
      var prevBtn = root.querySelector('[data-nn-logo-prev]');
      var nextBtn = root.querySelector('[data-nn-logo-next]');
      var dotsHost = root.querySelector('[data-nn-logo-dots]');
      if (!track) return;

      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var AUTOPLAY_MS = 5000;

      var page = 0;
      var pages = 1;
      var perView = 1;
      var sliding = false;
      var timer = null;

      function measurePerView() {
        var width = originals[0].offsetWidth;
        if (!width) return 1;
        return Math.max(1, Math.round(track.clientWidth / width));
      }

      function setTransform(index, animate) {
        if (!animate) track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        if (!animate) {
          void track.offsetWidth; // flush the jump before re-enabling animation
          track.style.transition = '';
        }
      }

      function paintDots() {
        if (!dotsHost) return;
        var dots = dotsHost.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === page);
        }
      }

      function build() {
        perView = measurePerView();

        track.querySelectorAll('[data-nn-clone]').forEach(function (n) { n.remove(); });

        // Pad to a whole number of pages, then add one page of clones so the
        // strip can run past the end and snap back invisibly.
        var pad = (perView - (originals.length % perView)) % perView;
        for (var i = 0; i < pad + perView; i++) {
          var clone = originals[i % originals.length].cloneNode(true);
          clone.setAttribute('data-nn-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        pages = (originals.length + pad) / perView;

        if (dotsHost) {
          dotsHost.innerHTML = '';
          if (pages > 1) {
            for (var d = 0; d < pages; d++) {
              (function (index) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
                dot.addEventListener('click', function () { stopAutoplay(); goTo(index); });
                dotsHost.appendChild(dot);
              })(d);
            }
          }
        }

        if (page > pages - 1) page = 0;
        setTransform(page, false);
        paintDots();
      }

      function goTo(index) {
        if (sliding) return;
        page = Math.max(0, Math.min(pages - 1, index));
        setTransform(page, true);
        paintDots();
      }

      function next() {
        if (sliding || pages < 2) return;
        if (page < pages - 1) { goTo(page + 1); return; }

        // Run onto the cloned page, then snap back to the real first page.
        sliding = true;
        setTransform(pages, true);
        page = 0;
        paintDots();
        window.setTimeout(function () {
          setTransform(0, false);
          sliding = false;
        }, 520);
      }

      function prev() {
        if (sliding || pages < 2) return;
        if (page > 0) { goTo(page - 1); return; }

        // Jump to the identical-looking clone page, then animate backwards.
        setTransform(pages, false);
        page = pages - 1;
        setTransform(page, true);
        paintDots();
      }

      function startAutoplay() {
        if (reduceMotion || timer) return;
        timer = window.setInterval(next, AUTOPLAY_MS);
      }

      function stopAutoplay() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); next(); });

      window.addEventListener('resize', build);
      window.addEventListener('load', build);
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(build).observe(track);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stopAutoplay(); } else if (!reduceMotion) { startAutoplay(); }
      });

      build();
      startAutoplay();
    });

    /* --- Best sellers carousel arrows --- */
    document.querySelectorAll('[data-nn-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-nn-carousel-track]');
      var prev = root.querySelector('[data-nn-carousel-prev]');
      var next = root.querySelector('[data-nn-carousel-next]');
      var counter = root.querySelector('[data-nn-carousel-counter]');
      if (!track) return;

      function pageSize() {
        var card = track.querySelector('.bs-card');
        if (!card) return track.clientWidth;
        var gap = 20;
        var perView = Math.max(1, Math.floor(track.clientWidth / (card.offsetWidth + gap)));
        return perView * (card.offsetWidth + gap);
      }

      function updateCounter() {
        if (!counter) return;
        var step = pageSize() || 1;
        var pages = Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / step) + 1);
        var current = Math.min(pages, Math.round(track.scrollLeft / step) + 1);
        counter.textContent = current + ' / ' + pages;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollLeft -= pageSize(); });
      if (next) next.addEventListener('click', function () { track.scrollLeft += pageSize(); });
      track.addEventListener('scroll', updateCounter, { passive: true });
      window.addEventListener('resize', updateCounter);
      window.addEventListener('load', updateCounter);
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(updateCounter).observe(track);
      }
      updateCounter();
    });
  });
})();

/* --- Healthy Habit Tracker popup (DUTCH hormonal test page) -----------------
   The tracker at the bottom of /pages/dutch-hormonal-test is rendered by the
   Globo form app, not by the theme. We therefore MOVE that exact node into a
   modal and put it back when the modal closes.

   Why move rather than copy: two live copies of the same form fight over
   element ids, and a clone loses the handlers the app bound to the original,
   so the copy would look right but never submit. Moving keeps one form, with
   its handlers and its submission intact. Nothing is deleted from the page —
   the node is only borrowed, and it is restored to its exact position on close.

   Self-contained on purpose: appended as its own IIFE so no existing behaviour
   is touched. Shows once per browsing session; change SESSION_ONLY to false to
   show it on every page view. */
(function habitTrackerPopup() {
  'use strict';

  var PATH        = '/pages/dutch-hormonal-test';
  var DELAY_MS    = 3500;   // matches the 3–4s the lead popup uses
  var SESSION_ONLY = true;
  var KEY         = 'nn-habit-popup-seen';

  if (window.location.pathname.replace(/\/+$/, '') !== PATH) return;
  if (SESSION_ONLY) {
    try { if (window.sessionStorage.getItem(KEY)) return; } catch (e) {}
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  onReady(function () {
    /* The app injects asynchronously, so poll until the fields actually exist —
       moving the shell before the app has filled it would strand an empty box. */
    var tries = 0;
    var poll = window.setInterval(function () {
      tries++;
      var formEl = document.querySelector('.globo-formbuilder');
      if (formEl && formEl.querySelector('input, textarea, select, button')) {
        window.clearInterval(poll);
        window.setTimeout(function () { openModal(formEl); }, DELAY_MS);
      } else if (tries > 60) {
        window.clearInterval(poll);   // ~30s; app absent or disabled, fail quietly
      }
    }, 500);
  });

  function openModal(formEl) {
    if (document.querySelector('[data-nn-habit-popup]')) return;
    if (!formEl.parentNode) return;
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}

    /* Placeholder marks where the form came from so it goes back exactly there. */
    var slot = document.createElement('div');
    slot.setAttribute('data-nn-habit-slot', '');
    formEl.parentNode.insertBefore(slot, formEl);

    var modal = document.createElement('div');
    modal.className = 'nn-habit-modal';
    modal.setAttribute('data-nn-habit-popup', '');
    modal.innerHTML =
      '<div class="nn-habit-backdrop" data-nn-habit-close></div>' +
      '<div class="nn-habit-panel" role="dialog" aria-modal="true"' +
      ' aria-label="Download our Healthy Habit Tracker">' +
        '<button type="button" class="nn-habit-close" data-nn-habit-close' +
        ' aria-label="Close">&times;</button>' +
        '<div class="nn-habit-content"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.nn-habit-content').appendChild(formEl);

    /* Remember the previous value rather than assuming '' — the page was left
       scroll-locked once before by a popup that reset it blindly. */
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    function close() {
      if (slot.parentNode) {
        slot.parentNode.insertBefore(formEl, slot);
        slot.parentNode.removeChild(slot);
      }
      if (modal.parentNode) modal.parentNode.removeChild(modal);
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }

    modal.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute('data-nn-habit-close')) close();
    });
    document.addEventListener('keydown', onKey);
  }
})();
